(function () {
  var settingsBtn = document.getElementById('jestee-settings-btn');
  var settingsMenu = document.getElementById('jestee-settings-menu');
  var accountBtn = document.getElementById('jestee-account-btn');
  var accountMenu = document.getElementById('jestee-account-menu');
  var suggest = document.getElementById('jestee-suggest');

  if (settingsBtn && settingsMenu) {
    settingsBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      settingsMenu.classList.toggle('is-open');
      if (accountMenu) accountMenu.classList.remove('is-open');
    });
  }
  if (accountBtn && accountMenu) {
    accountBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      accountMenu.classList.toggle('is-open');
      if (settingsMenu) settingsMenu.classList.remove('is-open');
    });
  }

  document.addEventListener('click', function (e) {
    if (settingsMenu && !e.target.closest('.jestee-settings')) settingsMenu.classList.remove('is-open');
    if (accountMenu && !e.target.closest('.jestee-account')) accountMenu.classList.remove('is-open');
    if (suggest && suggest.classList.contains('is-open') && !e.target.closest('.jestee-tagbar')) {
      closeSuggestGlobal();
    }
  }, true);

  var jesteeColors = ['var(--jestee-red)', 'var(--jestee-blue)', 'var(--jestee-green)', 'var(--jestee-yellow)'];
  if (accountBtn) {
    var avatarColor = jesteeColors[Math.floor(Math.random() * jesteeColors.length)];
    accountBtn.style.color = avatarColor;
    accountBtn.style.background = 'color-mix(in srgb, ' + avatarColor + ' 18%, var(--jestee-surface-2))';
  }
  var allTagColor = jesteeColors[Math.floor(Math.random() * jesteeColors.length)];
  function setAllTagActive(isActive) {
    var allTagEl = document.querySelector('.jestee-tag[data-tag-filter="all"]');
    if (!allTagEl) return;
    if (isActive) {
      allTagEl.style.background = allTagColor;
      allTagEl.style.color = '#fff';
    } else {
      allTagEl.style.background = '';
      allTagEl.style.color = '';
    }
  }
  setAllTagActive(true);

  var saved = localStorage.getItem('jestee-theme');
  if (saved === 'dark') document.documentElement.classList.add('jestee-dark');

  var settingsToggle = document.getElementById('jestee-darkmode-toggle');
  if (settingsToggle) {
    if (document.documentElement.classList.contains('jestee-dark')) {
      settingsToggle.classList.add('jestee-toggle-on');
      settingsToggle.setAttribute('aria-checked', 'true');
    }
    settingsToggle.addEventListener('click', function () {
      document.documentElement.classList.toggle('jestee-dark');
      var isDark = document.documentElement.classList.contains('jestee-dark');
      localStorage.setItem('jestee-theme', isDark ? 'dark' : 'light');
      settingsToggle.classList.toggle('jestee-toggle-on', isDark);
      settingsToggle.setAttribute('aria-checked', String(isDark));
    });
  }

  function parseColorImages(str) {
    if (!str) return [];
    return str.split('||').filter(Boolean).map(function (entry) {
      var parts = entry.split('::');
      return { color: parts[0] || '', url: parts[1] || '' };
    }).filter(function (e) { return e.url; });
  }

    function weightedRandomImage(entries) {
    if (!entries.length) return null;
    var weights = entries.map(function (e) {
      var c = e.color.toLowerCase();
      return (c.indexOf('white') !== -1 || c.indexOf('black') !== -1) ? 6 : 1;
    });
    var total = weights.reduce(function (a, b) { return a + b; }, 0);
    var r = Math.random() * total;
    for (var i = 0; i < entries.length; i++) {
      if (r < weights[i]) return entries[i].url;
      r -= weights[i];
    }
    return entries[entries.length - 1].url;
  }

  function reorderFrontBack(list) {
    var n = list.length;
    if (n < 2 || n % 2 !== 0) return list;
    var half = n / 2;
    var fronts = list.slice(0, half);
    var backs = list.slice(half);
    var result = [];
    for (var i = 0; i < half; i++) {
      result.push(fronts[i]);
      result.push(backs[i]);
    }
    return result;
  }

  function initImageCycling(card) {
    var imagesStr = card.getAttribute('data-images') || '';
    var imageList = reorderFrontBack(imagesStr.split('|').filter(Boolean));
    if (imageList.length < 2) return;

    var img = card.querySelector('.jestee-card-img');
    var currentIndex = 0;
    var startUrl = img ? img.src : '';
    var startMatch = imageList.findIndex(function (u) { return startUrl.indexOf(u.split('?')[0]) !== -1 || u.indexOf(startUrl.split('?')[0]) !== -1; });
    if (startMatch !== -1) currentIndex = startMatch;

    var preloaded = false;
    function preloadAll() {
      if (preloaded) return;
      preloaded = true;
      imageList.forEach(function (src) {
        var pre = new Image();
        pre.src = src;
      });
    }
    card.addEventListener('mouseenter', preloadAll);

    var prevBtn = card.querySelector('.jestee-card-arrow-prev');
    var nextBtn = card.querySelector('.jestee-card-arrow-next');

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        preloadAll();
        currentIndex = (currentIndex - 1 + imageList.length) % imageList.length;
        img.src = imageList[currentIndex];
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        preloadAll();
        currentIndex = (currentIndex + 1) % imageList.length;
        img.src = imageList[currentIndex];
      });
    }
  }

  function initGrid(grid) {
    var cardsArray = Array.prototype.slice.call(grid.querySelectorAll('.jestee-card'));

    cardsArray.forEach(function (card) {
      var entries = parseColorImages(card.getAttribute('data-color-images'));
      var chosen = weightedRandomImage(entries);
      if (chosen) {
        var img = card.querySelector('.jestee-card-img');
        if (img) img.src = chosen;
      }
    });

    for (var i = cardsArray.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = cardsArray[i];
      cardsArray[i] = cardsArray[j];
      cardsArray[j] = tmp;
    }
    cardsArray.forEach(function (card) { grid.appendChild(card); });

    function layoutMasonry() {
      var containerWidth = grid.clientWidth;
      if (!containerWidth) return;
      var gap = 24;
      var columns = containerWidth > 1100 ? 5 : containerWidth > 800 ? 4 : containerWidth > 550 ? 3 : 2;
      var colWidth = (containerWidth - gap * (columns - 1)) / columns;
      var colHeights = new Array(columns).fill(0);

      cardsArray.forEach(function (card) {
        if (card.classList.contains('is-hidden')) return;
        var media = card.querySelector('.jestee-card-media');
        var img = media ? media.querySelector('img') : null;

        card.style.width = colWidth + 'px';

        if (img && img.naturalWidth) {
          var ratio = img.naturalHeight / img.naturalWidth;
          if (typeof card._variance === 'undefined') {
            card._variance = 0.82 + Math.random() * 0.36;
          }
          media.style.height = Math.round(ratio * colWidth * card._variance) + 'px';
        }

        var minCol = 0;
        for (var c = 1; c < columns; c++) {
          if (colHeights[c] < colHeights[minCol]) minCol = c;
        }
        var left = minCol * (colWidth + gap);
        var top = colHeights[minCol];
        card.style.left = left + 'px';
        card.style.top = top + 'px';

        var totalHeight = card.offsetHeight;
        colHeights[minCol] = top + totalHeight + gap;
      });

      grid.style.height = Math.max.apply(null, colHeights.concat([0])) + 'px';
    }

        var images = grid.querySelectorAll('.jestee-card-img');
    var loadPromises = Array.prototype.map.call(images, function (img) {
      return new Promise(function (resolve) {
        if (img.complete && img.naturalWidth) return resolve();
        // Never let one slow/broken image block the whole layout forever
        var settled = false;
        var finish = function () { if (!settled) { settled = true; resolve(); } };
        img.addEventListener('load', finish);
        img.addEventListener('error', finish);
        setTimeout(finish, 4000);
      });
    });
    Promise.all(loadPromises).then(layoutMasonry);

    // Safety net: re-run layout a moment later too, in case any image was still
    // mid-load when the first pass ran, or loaded right at the edge of the timeout.
    setTimeout(layoutMasonry, 1200);
    setTimeout(layoutMasonry, 3000);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(layoutMasonry, 150);
    });

    cardsArray.forEach(initImageCycling);

    return { cardsArray: cardsArray, layoutMasonry: layoutMasonry };
  }

  document.querySelectorAll('.jestee-cat-grid').forEach(function (grid) {
    initGrid(grid);
  });

  document.querySelectorAll('.jestee-shelf-row').forEach(function (row) {
    var track = row.querySelector('.jestee-shelf-track');
    if (!track) return;

    var cards = track.querySelectorAll('.jestee-card');
    cards.forEach(function (card) {
      var entries = parseColorImages(card.getAttribute('data-color-images'));
      var chosen = weightedRandomImage(entries);
      if (chosen) {
        var img = card.querySelector('.jestee-card-img');
        if (img) img.src = chosen;
      }
    });
    cards.forEach(initImageCycling);

    var prevBtn = row.querySelector('.jestee-shelf-arrow-prev');
    var nextBtn = row.querySelector('.jestee-shelf-arrow-next');

    function scrollDistance() {
      var firstCard = track.querySelector('.jestee-card');
      var cardWidth = firstCard ? firstCard.getBoundingClientRect().width + 16 : 216;
      return cardWidth * 2;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -scrollDistance(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: scrollDistance(), behavior: 'smooth' });
      });
    }
  });

  var input = document.getElementById('jestee-tag-input');
  var allTag = document.querySelector('.jestee-tag[data-tag-filter="all"]');
  var grid = document.getElementById('jestee-grid');
  var closeSuggestGlobal = function () {};

  if (input && grid && suggest) {
    var gridInstance = initGrid(grid);
    var cards = gridInstance.cardsArray;
    var layoutMasonry = gridInstance.layoutMasonry;
    var activeTags = [];

    function openSuggest() {
      suggest.classList.add('is-open');
      var color = jesteeColors[Math.floor(Math.random() * jesteeColors.length)];
      allTag.style.background = color;
      allTag.style.color = '#fff';
    }
    function closeSuggest() {
      suggest.classList.remove('is-open');
      allTag.style.background = '';
      allTag.style.color = '';
    }
    closeSuggestGlobal = closeSuggest;

    function applyFilter() {
      if (activeTags.length === 0) {
        cards.forEach(function (c) { c.classList.remove('is-hidden'); });
      } else {
        cards.forEach(function (card) {
          var cardTags = (card.getAttribute('data-tags') || '').split(',');
          var matches = activeTags.some(function (t) { return cardTags.indexOf(t) !== -1; });
          card.classList.toggle('is-hidden', !matches);
        });
      }
      layoutMasonry();
    }

    function addTagChip(tagHandle, label) {
      if (activeTags.indexOf(tagHandle) !== -1) return;
      activeTags.push(tagHandle);

      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'jestee-tag jestee-tag-active';
      chip.textContent = '#' + label;
      chip.setAttribute('data-tag-filter', tagHandle);
      chip.addEventListener('click', function (e) {
        e.stopPropagation();
        activeTags = activeTags.filter(function (t) { return t !== tagHandle; });
        chip.remove();
        if (activeTags.length === 0) allTag.classList.add('jestee-tag-active');
        applyFilter();
      });

      allTag.classList.remove('jestee-tag-active');
      setAllTagActive(false);
      allTag.parentNode.insertBefore(chip, allTag.nextSibling);
      input.value = '';
      closeSuggest();
      applyFilter();
    }

    allTag.addEventListener('click', function (e) {
      e.stopPropagation();
      activeTags = [];
      document.querySelectorAll('.jestee-tagbar .jestee-tag[data-tag-filter]:not([data-tag-filter="all"])').forEach(function (c) { c.remove(); });
      allTag.classList.add('jestee-tag-active');
      setAllTagActive(true);
      applyFilter();

      if (suggest.classList.contains('is-open')) {
        closeSuggest();
      } else {
        openSuggest();
      }
    });

    input.addEventListener('focus', function () { openSuggest(); });

    suggest.querySelectorAll('.jestee-suggest-chip').forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        e.stopPropagation();
        addTagChip(chip.getAttribute('data-tag'), chip.textContent.replace('#', ''));
      });
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && input.value.trim()) {
        e.preventDefault();
        var raw = input.value.trim();
        addTagChip(raw.toLowerCase().replace(/\s+/g, '-'), raw);
      }
    });
  }

  var qtyInput = document.getElementById('jestee-qty-input');
  var qtyMinus = document.getElementById('jestee-qty-minus');
  var qtyPlus = document.getElementById('jestee-qty-plus');
  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function () {
      var v = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
      qtyInput.value = v;
    });
    qtyPlus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value || '1', 10) + 1;
      qtyInput.value = v;
    });
  }

  // ---- Product page: variant option pills (moved above the gallery so its click logic
  // exists before the gallery ever needs to trigger a color pill programmatically) ----
  var optionPills = document.querySelectorAll('.jestee-option-pill');
  var variantInput = document.getElementById('jestee-selected-variant');
  if (optionPills.length && variantInput && typeof window.jesteeProductVariants !== 'undefined') {
    var selected = {};
    document.querySelectorAll('.jestee-option-group').forEach(function (group, idx) {
      var activePill = group.querySelector('.jestee-option-active');
      if (activePill) selected[idx] = activePill.getAttribute('data-value');
    });

    function updateVariant() {
      var match = window.jesteeProductVariants.find(function (v) {
        return Object.keys(selected).every(function (idx) { return v.options[idx] === selected[idx]; });
      });
      if (match) variantInput.value = match.id;
    }

    optionPills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var idx = pill.getAttribute('data-option-index');
        var group = pill.closest('.jestee-option-group');
        group.querySelectorAll('.jestee-option-pill').forEach(function (p) { p.classList.remove('jestee-option-active'); });
        pill.classList.add('jestee-option-active');
        selected[idx] = pill.getAttribute('data-value');
        updateVariant();
      });
    });
  }

  // ---- Product page: main image gallery ----
  var mainImage = document.getElementById('jestee-main-image');
  var gallery = document.getElementById('jestee-gallery');
  if (mainImage && gallery) {
    var thumbsContainer = gallery.querySelector('.jestee-product-thumbs');
    var rawThumbs = Array.prototype.slice.call(gallery.querySelectorAll('.jestee-thumb'));
    if (rawThumbs.length >= 2 && rawThumbs.length % 2 === 0 && thumbsContainer) {
      var half = rawThumbs.length / 2;
      var fronts = rawThumbs.slice(0, half);
      var backs = rawThumbs.slice(half);
      var interleaved = [];
      for (var fi = 0; fi < half; fi++) {
        interleaved.push(fronts[fi]);
        if (backs[fi]) interleaved.push(backs[fi]);
      }
      interleaved.forEach(function (btn, idx) {
        btn.setAttribute('data-index', idx);
        thumbsContainer.appendChild(btn);
      });
    }
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.jestee-thumb'));
    var galleryIndex = 0;

    var colorEntries = parseColorImages(gallery.getAttribute('data-color-images'));
    var chosenColorImg = weightedRandomImage(colorEntries);
    if (chosenColorImg) {
      mainImage.src = chosenColorImg;
      var matchIdx = thumbs.findIndex(function (t) { return t.getAttribute('data-full') === chosenColorImg; });
      if (matchIdx !== -1) galleryIndex = matchIdx;
    }

    // Work out which color each thumbnail belongs to, using the same front-image
    // list we already know is reliable (variant.featured_image per color).
    var colorOptionIndex = parseInt(gallery.getAttribute('data-color-option-index') || '-1', 10);
    var colorForIndex = [];
    if (colorOptionIndex >= 0) {
      thumbs.forEach(function (t, idx) {
        var url = t.getAttribute('data-full');
        var match = colorEntries.find(function (e) { return e.url === url; });
        if (match) {
          colorForIndex[idx] = match.color;
          if (colorForIndex[idx + 1] === undefined) colorForIndex[idx + 1] = match.color;
        }
      });
    }

    function syncColorPill(colorName) {
      if (colorOptionIndex < 0 || !colorName) return;
      var pills = document.querySelectorAll('.jestee-option-pill[data-option-index="' + colorOptionIndex + '"]');
      pills.forEach(function (p) {
        if (p.getAttribute('data-value') === colorName && !p.classList.contains('jestee-option-active')) {
          p.click();
        }
      });
    }

    function setActiveThumb(idx) {
      thumbs.forEach(function (t) { t.classList.remove('jestee-thumb-active'); });
      if (thumbs[idx]) thumbs[idx].classList.add('jestee-thumb-active');
      syncColorPill(colorForIndex[idx]);
    }
    setActiveThumb(galleryIndex);

    thumbs.forEach(function (thumb, idx) {
      thumb.addEventListener('click', function () {
        galleryIndex = idx;
        mainImage.src = thumb.getAttribute('data-full');
        setActiveThumb(galleryIndex);
      });
    });

    var mainPrev = gallery.querySelector('.jestee-main-arrow-prev');
    var mainNext = gallery.querySelector('.jestee-main-arrow-next');
    if (mainPrev && thumbs.length > 1) {
      mainPrev.addEventListener('click', function () {
        galleryIndex = (galleryIndex - 1 + thumbs.length) % thumbs.length;
        mainImage.src = thumbs[galleryIndex].getAttribute('data-full');
        setActiveThumb(galleryIndex);
      });
    }
    if (mainNext && thumbs.length > 1) {
      mainNext.addEventListener('click', function () {
        galleryIndex = (galleryIndex + 1) % thumbs.length;
        mainImage.src = thumbs[galleryIndex].getAttribute('data-full');
        setActiveThumb(galleryIndex);
      });
    }
  }
})();